import { Injectable } from "@angular/core";
import { createAction } from "@ngrx/store";

Injectable({
  providedIn: "root",
});
export class AdminUsersActions {
  static openFeaturesModal = createAction("[AdminUser] Open Feature Modal");

  static setConfirmationOnModalClose = createAction(
    "[AdminUser] Set Confirmation Feature Modal"
  );
}
